import { theme } from '@cockpit/levi-ui/theme'
import styled from '@emotion/styled'

export const CustomTooltipContent = styled.div`
  font-weight: ${theme.font.weight[6]};
  line-height: 1.6em;
`

export const Container = styled.div``
